import { render, staticRenderFns } from "./PsSharedWeeklyWeight.vue?vue&type=template&id=088ead00&scoped=true&"
import script from "./PsSharedWeeklyWeight.vue?vue&type=script&lang=js&"
export * from "./PsSharedWeeklyWeight.vue?vue&type=script&lang=js&"
import style0 from "./PsSharedWeeklyWeight.vue?vue&type=style&index=0&id=088ead00&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "088ead00",
  null
  
)

export default component.exports